import { defineResource } from '@tnn/core'
import { z } from 'zod'

/**
 * company.profile: the company's details — printed on document headers, shown to everyone in Company, changed by the
 * super admin. One record only. Exported as `company` (`profile` is HR's private details).
 */
export const company = defineResource({
  app: 'company',
  name: 'profile',
  schema: z.object({
    name: z.string().trim().min(1).max(200),
    nameEn: z.string().trim().max(200).nullish(),
    taxId: z
      .string()
      .regex(/^\d{13}$/)
      .nullish(),
    branch: z.string().trim().max(10).nullish(),
    address: z.string().max(500).nullish(),
    phone: z.string().trim().max(30).nullish(),
    email: z.email().nullish(),
    website: z.string().trim().max(200).nullish(),
    /** Whose kept signature the company's documents print as the authorized signer (ผู้มีอำนาจลงนาม) */
    signerUserId: z.string().nullish(),
    signerTitle: z.string().trim().max(100).nullish(),
  }),
  fields: {
    name: { form: { span: 6 } },
    nameEn: { form: { span: 6 } },
    taxId: { type: 'taxId', form: { span: 6 } },
    branch: { form: { span: 6 } },
    address: { type: 'textarea', form: { span: 12 } },
    phone: { type: 'phone', form: { span: 4 } },
    email: { form: { span: 4 } },
    website: { form: { span: 4 } },
    signerUserId: { type: 'ref', ref: { resource: 'admin.user' }, form: { span: 6 } },
    signerTitle: { form: { span: 6, placeholder: 'กรรมการผู้จัดการ' } },
  },
  title: 'name',
  // `migrate`: moving in from Business Zero (Admin → ย้ายข้อมูล); no role gives it, so only a super admin
  actions: ['read', 'update', 'migrate'],
})
